<script>
import { Terminal } from 'xterm'
import { FitAddon } from 'xterm-addon-fit'
import 'xterm/css/xterm.css'
import { mapState, mapActions, mapMutations } from 'vuex'
import axios from 'axios'

export default {
   name: 'UmkScrap',
   components: {},
   data() {
      return {
         pageList: 1,
         totalPage: 0,
         grandTotal: 0,
         request: null,
         file: null,
         term: null,
         fitAddon: null,
      }
   },
   computed: {
      ...mapState({
         myData: state => state.OssScrapLkpmUmk.data,
         myCountTotal: state => state.OssScrapLkpmUmk.countTotal,
         myCount: state => state.OssScrapLkpmUmk.countAll,
         myCurrent: state => state.OssScrapLkpmUmk.current,
         mySuccess: state => state.OssScrapLkpmUmk.success,
         myFailed: state => state.OssScrapLkpmUmk.failed,
         myState: state => state.OssScrapLkpmUmk.runningState,
      }),
      isLoading() {
         return this.$store.state.isLoading
      },
      current: {
         get() {
            return this.myCurrent
         },
         set(value) {
            let newVal

            if (value) {
               newVal = value
            } else {
               newVal = 0
            }

            this.updateCurrent(parseInt(newVal, 10))
         },
      },
   },
   mounted() {
      // 1. Inisialisasi Terminal
      this.term = new Terminal({
         cursorBlink: true,
         fontSize: 14,
         fontFamily: 'Consolas, "Courier New", monospace',
         theme: {
            background: '#021a23',
            foreground: '#d4d4d4',
         },
      })
      // 2. Load Addon Fit
      this.fitAddon = new FitAddon()
      this.term.loadAddon(this.fitAddon)

      // 3. Pasang Terminal ke elemen DOM
      this.term.open(this.$refs.terminalContainer)

      // 4. Sesuaikan ukuran awal
      this.fitAddon.fit()

      window.addEventListener('resize', this.handleResize)

      this.onLoadList()
   },
   beforeDestroy() {
      // Bersihkan (Dispose) Terminal untuk mencegah memory leak di Vue 2
      window.removeEventListener('resize', this.handleResize)
      if (this.term) {
         this.term.dispose()
      }
   },
   methods: {
      ...mapActions({
         getData: 'OssScrapLkpmUmk/getData',
         getDataError: 'OssScrapLkpmUmk/getDataError',
         runScrap: 'OssScrapLkpmUmk/runScrap',
         loginOss: 'OssScrapLkpmUmk/login',
         runScrapList: 'OssScrapLkpmUmk/runScrapList',
         importData: 'OssScrapLkpmUmk/importData',
      }),
      ...mapMutations({
         updateCurrent: 'OssScrapLkpmUmk/SET_CURRENT',
         setState: 'OssScrapLkpmUmk/SET_STATE',
         setCancelToken: 'OssScrapLkpmUmk/SET_CANCEL_TOKEN',
         setReset: 'OssScrapLkpmUmk/SET_RESET',
      }),
      run() {
         if (!this.myState) {
            return
         }

         const item = this.myData[this.myCurrent]
         if (!item) {
            this.setState(false)
            return
         }

         this.write(`Run ${this.myCurrent + 1} / ${this.myCount}`)
         this.write(`------ Body : { id_laporan : ${item.id}}`)

         this.runScrap(item.id).then(
            data => {
               if (data?.data) {
                  this.write(`------ Response : \x1B[1;3;32m${JSON.stringify(data.data)}\x1B[0m `)
               } else {
                  // Jika request gagal, tampilkan pesan error + body response dari server (jika ada)
                  const errMessage = [
                  data?.message,
                  data?.response?.data ? JSON.stringify(data.response.data) : null,
                  ].filter(Boolean).join(' | ')

                  this.write(`------ Response : \x1B[1;3;31m${errMessage || JSON.stringify(data)}\x1B[0m `)
               }

               if (this.myCurrent < this.myCount) {
                  this.run()
               } else {
                  this.setState(false)
                  this.write('Finish : Download PDF LKPM UMK')
               }
            },
            () => {
               this.run()
            },
         )
      },
      onStart() {
         if (!this.myCount) {
            this.write('\x1B[1;3;31mData kosong, silakan Load All / Update List terlebih dahulu\x1B[0m')
            return
         }
         this.setReset()
         this.write('Start : Download PDF LKPM UMK')
         const axiosSource = axios.CancelToken.source()
         this.request = { cancel: axiosSource.cancel }
         this.setCancelToken(axiosSource.token)
         this.setState(true)
         this.run()
      },
      onStop() {
         this.write('\x1B[1;3;31mStop\x1B[0m')
         this.setState(false)
         if (this.request) {
            this.request.cancel()
         }
      },
      onRunList() {
         this.write('Start : Update List LKPM UMK')
         this.write(`------ Page : ${this.pageList}`)

         const axiosSource = axios.CancelToken.source()
         this.request = { cancel: axiosSource.cancel }
         this.setCancelToken(axiosSource.token)
         this.setState(true)

         this.runScrapList(this.pageList).then(
            res => {
               this.totalPage = res.total_page
               this.grandTotal += res.total_item
               this.write(`------ Item : ${res.total_item}`)
               this.write(`------ Total : ${this.grandTotal}`)
               this.pageList = parseInt(this.pageList, 10) + 1

               if (this.pageList > this.totalPage) {
                  this.write('Finish : Update List LKPM UMK')
                  this.getData()
                     .then(result => {
                        this.write(`------ Total Data : ${JSON.stringify(result.length)}`)
                     })
                  this.pageList = 1
                  this.totalPage = 0
                  this.grandTotal = 0
                  this.setState(false)
               } else {
                  this.onRunList()
               }
            },
            () => {
               this.write('------ \x1B[1;3;31mGagal mendapatkan list LKPM UMK\x1B[0m')
               this.setState(false)
            },
         )
      },
      onLoadList() {
         this.setReset()
         this.write('Start : Load list (All)')
         this.getData()
            .then(result => {
               this.write(`------ Total : ${JSON.stringify(result.length)}`)
            })
            .catch(error => {
               this.write(`------ \x1B[1;3;31m${JSON.stringify(error)}\x1B[0m`)
            })
      },
      onLoadListError() {
         this.setReset()
         this.write('Start : Load list error only (S3_path kosong)')
         this.getDataError()
            .then(result => {
               this.write(`------ Total : ${JSON.stringify(result.length)}`)
            })
            .catch(error => {
               this.write(`------ \x1B[1;3;31m${JSON.stringify(error)}\x1B[0m`)
            })
      },
      onLogin() {
         this.write('Login OSS')
         this.loginOss().then(
            res => {
               this.write(`------ ${res.message}`)
               this.$toast.success(res.message)
            },
            () => {
               this.write('------ \x1B[1;3;31mGagal Login\x1B[0m')
               this.$toast.error('Gagal Login')
            },
         )
      },
      onImport() {
         this.$bvModal.show('modal-import')
      },
      onSave() {
         if (this.file) {
            this.write('Start : Import Excel LKPM UMK')
            this.write(`------ File : ${this.file.name}`)
            this.importData(this.file).then(
               res => {
                  this.write(`------ Response : \x1B[1;3;32m${JSON.stringify(res)}\x1B[0m `)
                  this.$toast.success(res.message || 'Import berhasil')
                  this.file = null
                  this.$bvModal.hide('modal-import')
                  this.onLoadList()
               },
               () => {
                  this.write('------ \x1B[1;3;31mGagal Import Excel\x1B[0m')
                  this.$toast.error('Gagal Import Excel')
               },
            )
         } else {
            this.write('------ \x1B[1;3;31mFile Excel belum dipilih\x1B[0m')
            this.$toast.error('File Excel belum dipilih')
         }
      },
      write(text) {
         if (this.term) {
            this.term.write(`${text}\n\r`)
         }
      },
      handleResize() {
         if (this.fitAddon) {
            this.fitAddon.fit()
         }
      },
   },
}
</script>

<template>
   <b-row>
      <b-col cols="12" xl="4" lg="4" md="4">
         <b-card title="Jumlah">
            <b-row>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center mr-2">
                     <b-avatar variant="light-primary" rounded>
                        <feather-icon icon="FileTextIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myCountTotal }}
                        </h5>
                        <small>Total LKPM UMK List</small>
                     </div>
                  </div>
               </b-col>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center">
                     <b-avatar variant="light-success" rounded>
                        <feather-icon icon="CheckCircleIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myCount }}
                        </h5>
                        <small>Total yang akan didownload</small>
                     </div>
                  </div>
               </b-col>
            </b-row>
         </b-card>
         <b-card title="Status">
            <b-row>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center mr-2">
                     <b-avatar variant="light-primary" rounded>
                        <feather-icon icon="MapPinIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myCurrent }}
                        </h5>
                        <small>Current / Posisi</small>
                     </div>
                  </div>
               </b-col>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center">
                     <b-avatar variant="light-success" rounded>
                        <feather-icon icon="TrendingUpIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ mySuccess }}
                        </h5>
                        <small>Sukses</small>
                     </div>
                  </div>
               </b-col>
               <b-col cols="21" xl="12" class="mb-2">
                  <div class="d-flex align-items-center">
                     <b-avatar variant="light-danger" rounded>
                        <feather-icon icon="AlertTriangleIcon" size="18" />
                     </b-avatar>
                     <div class="ml-1">
                        <h5 class="mb-0">
                           {{ myFailed }}
                        </h5>
                        <small>Error</small>
                     </div>
                  </div>
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-form-input v-model="current" :disabled="myState" type="number" placeholder="Enter Posisi" />
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-button :disabled="myState || isLoading" variant="secondary" block @click="onStart">
                     <span v-show="isLoading" class="spinner-border spinner-border-sm" />
                     Start
                  </b-button>
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-button :disabled="!myState" variant="danger" block @click="onStop">
                     Stop
                  </b-button>
               </b-col>
               <b-col md="12" class="mb-1">
                  <hr>
                  <b-button :disabled="myState || isLoading" variant="secondary" block @click="onLogin">
                     <span v-show="isLoading" class="spinner-border spinner-border-sm" />
                     Login
                  </b-button>
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-button :disabled="myState || isLoading" variant="secondary" block @click="onImport">
                     <feather-icon icon="UploadIcon" class="mr-25" />
                     Import Excel
                  </b-button>
               </b-col>
               <b-col md="6" class="mb-1">
                  <hr>
                  <b-button :disabled="myState || isLoading" variant="secondary" block @click="onLoadList()">
                     Load All
                  </b-button>
               </b-col>
               <b-col md="6" class="mb-1">
                  <hr>
                  <b-button :disabled="myState || isLoading" variant="secondary" block @click="onLoadListError()">
                     Load Error Only
                  </b-button>
               </b-col>
            </b-row>
         </b-card>
         <b-card title="Update List LKPM UMK">
            <b-row>
               <b-col md="12" class="mb-1">
                  <b-form-input
                     v-model="pageList"
                     :disabled="myState || isLoading"
                     type="number"
                     placeholder="Page"
                     label="Page"
                  />
               </b-col>
               <b-col md="12" class="mb-1">
                  <b-button :disabled="myState || isLoading" variant="secondary" block @click="onRunList">
                     <span v-show="isLoading" class="spinner-border spinner-border-sm" />
                     Update List LKPM UMK
                  </b-button>
               </b-col>
            </b-row>
         </b-card>
      </b-col>
      <b-col cols="12" md="8" xl="8" lg="8">
         <b-card title="Action">
            <b-row>
               <b-col md="12">
                  <div>
                     <!-- <label>Progress label with precision</label> -->
                     <b-progress
                        :value="myCurrent"
                        :max="myCount"
                        precision="2"
                        show-progress
                        variant="primary"
                        class="progress-bar-warning"
                     />
                  </div>
               </b-col>
            </b-row>
         </b-card>
         <b-card title="Logs">
            <b-row>
               <b-col md="12">
                  <div>
                     <!-- <label>Progress label with precision</label> -->
                     <div id="terminal-container" ref="terminalContainer" />
                  </div>
               </b-col>
            </b-row>
         </b-card>
      </b-col>

      <b-modal
         id="modal-import"
         scrollable
         size="lg"
         centered
         hide-footer
         title="Form Import LKPM UMK"
         no-close-on-backdrop
      >
         <b-form-group label="File Excel">
            <b-form-file
               v-model="file"
               accept=".xlsx, .xls"
               placeholder="Choose a file or drop it here..."
               drop-placeholder="Drop file here..."
            />
         </b-form-group>
         <hr>
         <b-button
            variant="primary"
            type="button"
            class="float-right"
            :disabled="isLoading"
            @click.prevent="onSave"
         >
            <span v-show="isLoading" class="spinner-border spinner-border-sm" />
            Import
         </b-button>
      </b-modal>
   </b-row>
</template>

<style scoped>
#terminal-container {
  /* Berikan dimensi yang jelas pada kontainer */
  width: 100%;
  height: 400px;
  border: 1px solid #555;
  padding: 5px;
}
</style>
